/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

const defaults = {
  mounted: false,
};

export interface ComponentState {
  mounted: boolean;
};

export interface ActionType {
  type: string;
  payload: any;
};

export default (state: ComponentState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_STATE: {
      return Object.assign({}, state, {
        ...action.payload
      });
    }
    default:
      return { ...state };
  }
};
